import React, { useState, useRef, useEffect } from 'react';
import DetectDevice from './DeviceDetector';
import { BsInstagram, BsTwitter, BsTiktok } from 'react-icons/bs';

export const Info_contact = ({}) => {
  return (
    <>
      <span>
        <h5>Contact</h5>
      </span>
      <div className="info-line-container">
        <span className="info-line"></span>
      </div>
      Please reach out to us at{' '}
      <a href="mailto:todem@latentculture.com" rel="noreferrer" target="_blank">
        todem@latentculture.com
      </a>{' '}
      with any inquiries.
      <br></br>
      <br></br>
      <span>
        <h5>Follow Us</h5>
      </span>
      <div className="info-line-container">
        <span className="info-line"></span>
      </div>
      <br></br>
      <BsTwitter
        className="icon"
        onClick={() =>
          (window.location.href = 'https://twitter.com/latentculture')
        }
        style={{
          cursor: 'pointer',
          pointerEvents: 'all',
          color: 'white',
          pointer: 'cursor',
          fontSize: DetectDevice ? 45 : 35,
        }}
      />
      <BsInstagram
        className="icon"
        onClick={() =>
          (window.location.href =
            'https://www.instagram.com/jasonsalavonstudio/')
        }
        style={{
          marginLeft: '20px',
          pointerEvents: 'all',
          pointer: 'cursor',
          color: 'white',
          fontSize: DetectDevice ? 45 : 35,
        }}
      />
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      {DetectDevice ? (
        <h6>
          {' '}
          <a href="https://www.latentculture.com/todem/TODEM-License_Agreement.pdf">
            {' '}
            &emsp; &emsp; &emsp; NFT License Agreement{' '}
          </a>{' '}
        </h6>
      ) : null}
    </>
  );
};

export default Info_contact;
